<template>
  <section class="section">
    <div class="container container-small">
      <header>
        <transition name="text">
          <TextSection
            v-if="visible || mobile"
            :header="header"
            :description="description"
            :underline="true"
            :uppercase="false"
            :cutLength="360"
            :cutLengthTextBig="240" />
        </transition>
      </header>
      <transition name="pulse">
        <img alt="Image"
             class="image-overflow"
            :class="{'image-overflow-visible' : visible}"
            :src="image" />
      </transition>
    </div>
  </section>
</template>
<script>
import TextSection from '@/components/TextSection.vue'

export default {
  name: 'overflowSection',
  props: ['description', 'header', 'image', 'visible', 'mobile'],
  components: {
    TextSection
  }
}
</script>

<style scoped lang="scss">
  .section {
    .container {
      padding-top: 54px;
      display: flex;
      justify-content: flex-end;
      position: relative;
      min-height: 560px;
      @include tablet {
        flex-direction: column;
        padding-top: 40px;
      }
      @include mobile {
        flex-direction: column;
        padding-top: 40px;
      }
    }
  }
  header {
    // width: 380px;
    max-width: 50vw;
    /deep/ .parts-wrapper {
      width: 370px;
      height: 250px;
    }
    @include tablet {
      width: 100%;
      max-width: 100%;

      /deep/ {
        h2 {
          max-width: 100%;
        }
        .parts-wrapper {
          width: 100%;
        }
      }
    }
    @include mobile {
      width: 100%;
      max-width: 100%;
      /deep/ .parts-wrapper {
        width: 100%;
      }
      /deep/ .multi {
        .parts-wrapper {
          min-height: 280px;
          max-height: 280px;
        }
      }
    }
    @include mobile-small {
      /deep/ .multi {
        .parts-wrapper {
          min-height: 360px;
          max-height: 360px;
        }
      }
    }
    .font-size-l & {
      @include mobile {
        /deep/ .multi {
          .parts-wrapper {
            min-height: 200px;
          }
        }
      }
      @include mobile-small {
        /deep/ .multi {
          .parts-wrapper {
            min-height: 300px;
          }
        }
      }
    }
  }
  .image-overflow {
    position: absolute;
    top: 66px;
    // margin-top: -106px;
    left: -64px;
    max-height: 120%;
    width: 834px;
    max-width: 90vw;
    visibility: hidden;

    @include desktop {
      margin-top: 0;
    }
    @include tablet {
      position: relative;
      top: 40px;
      max-width: 100%;
      max-height: 100%;
      right: auto;
      left: 0;
      width: 100%;
      height: auto;
    }
    @include mobile {
      position: relative;
      top: 25px;
      margin-top: -50px;
      max-width: 100%;
      left: auto;
    }

    &-visible {
      visibility: visible;
    } // END .image-overflow-visible;
  }
  p {
    // float:left;
    // width:600px;
    // height:900px;
    // overflow:hidden;
    // margin:0 50px;
    // color:white;
    // font-size:13px;
    // padding:10px;
    // background: url(../assets/images/pan.jpg) top left no-repeat;
    // background-size:100% 100%;
    // /*declare shape using the shape function circle()*/
    // shape-inside: circle(160px at 400px 60px);
  }

  @supports (shape-outside: circle(50%)){
  /* styles only for browsers which support CSS Shapes */
  // p {
  //   shape-outside: circle(50%);
  // }
  }
</style>
